module.exports = __webpack_public_path__ + "static/media/button-watch.78d81baa.png";